import { MOMENT_MESSAGE_TYPE_OPTIONS, type MomentMessageType } from "../../data/momentOptions";
import { SelectBox } from "../shared";
import { inputCls } from "../shared";

type Props = {
  messageName: string;
  channel: string;
  channels: string[];
  messageType: MomentMessageType;
  ageAuthEnabled: boolean;
  adFlag: boolean;
  channelLocked?: boolean;
  messageTypeLocked?: boolean;
  messageTypeNotice?: string | null;
  onMessageNameChange: (value: string) => void;
  onChannelChange: (value: string) => void;
  onMessageTypeChange: (value: MomentMessageType) => void;
  onAgeAuthChange: (value: boolean) => void;
  onAdFlagChange: (value: boolean) => void;
};

export default function SendInfoSection({
  messageName, channel, channels, messageType, ageAuthEnabled, adFlag,
  channelLocked, messageTypeLocked, messageTypeNotice,
  onMessageNameChange, onChannelChange, onMessageTypeChange, onAgeAuthChange, onAdFlagChange,
}: Props) {
  return (
    <div className="tw-border tw-border-gray-200 tw-rounded-xl tw-overflow-hidden">
      <div className="tw-px-4 tw-py-3 tw-bg-gray-50">
        <span className="tw-text-sm tw-font-semibold tw-text-gray-800">발송 정보</span>
      </div>
      <div className="tw-p-4 tw-border-t tw-border-gray-200 tw-space-y-4">
        <div>
          <label className="tw-block tw-text-xs tw-text-gray-500 tw-mb-1.5">
            <span className="tw-text-red-500 tw-mr-1">*</span>
            메시지 이름
          </label>
          <input
            value={messageName}
            onChange={(e) => onMessageNameChange(e.target.value)}
            placeholder="메시지 이름을 입력해주세요. 최대 50자"
            className={inputCls}
          />
        </div>

        <div className="tw-grid tw-grid-cols-2 tw-gap-3">
          <div>
            <label className="tw-block tw-text-xs tw-text-gray-500 tw-mb-1.5">채널</label>
            <SelectBox
              value={channel}
              onChange={onChannelChange}
              options={channels.map((c) => ({ value: c, label: c }))}
              disabled={channelLocked}
            />
          </div>
          <div>
            <label className="tw-block tw-text-xs tw-text-gray-500 tw-mb-1.5">발송 유형</label>
            <SelectBox
              value={messageType}
              onChange={(val) => onMessageTypeChange(val as MomentMessageType)}
              options={MOMENT_MESSAGE_TYPE_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
              disabled={messageTypeLocked}
            />
          </div>
        </div>
        {messageTypeNotice && (
          <p className="tw-text-xs tw-text-amber-600">{messageTypeNotice}</p>
        )}

        <div className="tw-flex tw-gap-4 tw-pt-1">
          <label className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-700 tw-cursor-pointer">
            <input type="checkbox" checked={ageAuthEnabled} onChange={(e) => onAgeAuthChange(e.target.checked)} className="tw-w-4 tw-h-4" />
            연령인증 메시지
          </label>
          <label className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-700 tw-cursor-default">
            <input
              type="checkbox"
              checked={adFlag}
              readOnly
              onChange={() => {}}
              className="tw-sr-only"
              tabIndex={-1}
            />
            <span className="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-rounded-[4px] tw-border tw-border-[#7EA6FF] tw-bg-[#7EA6FF]">
              <svg viewBox="0 0 16 16" className="tw-w-3 tw-h-3 tw-text-white" fill="none" aria-hidden="true">
                <path d="M3.5 8.2 6.6 11.3 12.5 5.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            광고성 메시지
          </label>
        </div>
      </div>
    </div>
  );
}
